import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

// import { MobileSchedule } from '../model/common.model';


@Pipe({
    name: 'displayMinute'
})

export class DisplayMinute implements PipeTransform {

    integerDivider(numerator: number, divider: number) {
        return (numerator - (numerator % divider)) / divider;
    }

    rounding(value: number, nbDecimal: number): number {
          if (nbDecimal <= 0 ) {
            return value;
          }
          const p  = Math.pow(10, nbDecimal);
          return Math.round( value * p ) / p;
    }



  integerModulo(numerator: number, divider: number){
      return this.rounding(numerator % divider,2);
  }



  transform(value: number, fiveDigits:boolean = false, displaySignIfNegative: boolean = false,sixDigits:boolean=false,sevenDigits:boolean=false,displaySignIfPositive: boolean = false): any {
    //console.log('transform ' + JSON.stringify(value) + ' five: ' + fiveDigits + ' displayNegative: ' + displaySignIfNegative);
    if (fiveDigits){
      return this.transformWith5Digits(value,displaySignIfNegative,displaySignIfPositive);
    }
    if (sixDigits){
      return this.transformWith6Digits(value,displaySignIfNegative,displaySignIfPositive);
    }
    if (sevenDigits){
      return this.transformWith7Digits(value,displaySignIfNegative,displaySignIfPositive);
    }
    if (value) {
      let negative = false;
      if (value<0){
        negative = true;
        value = -1*value;
      }

      let hours: string = (this.integerDivider(value, 60))  + '';
      let min: string = this.integerModulo(value ,60) + '';
      if ( hours.length === 1 ) {
        hours = '0' + hours;
      }
      if ( min.length === 1 ) {
        min = '0' + min;
      }
      if (value<0){
        console.log(hours + ':' + min + ' => ' + value);
      }
      if (negative && displaySignIfNegative ){
        return "-" + hours + ":" + min;
      }else{
        if (displaySignIfPositive){
          return "+" + hours + ':' + min;
        }else{
          return hours + ':' + min;
        }
      }
    } else {
      if (displaySignIfPositive){
        return '+00:00';
      }else{
        return '00:00';
      }
    }
  }


  transformWith5Digits(value: number,displaySignIfNegative: boolean = false,displaySignIfPositive: boolean = false): any {
    // console.log('transform ' + JSON.stringify(value) + ' displaySignIfNegative: ' + displaySignIfNegative);
    if (value) {
      let negative = false;
      if (value<0){
        negative = true;
        value = -1*value;
      }
      let hours: string = (this.integerDivider(value, 60))  + '';
      let min: string = this.integerModulo(value ,60)  + '';
      if ( hours.length === 1 ) {
        hours = '0' + hours;
      }
      if ( hours.length === 2 ) {
        hours = '0' + hours;
      }
      if ( min.length === 1 ) {
        min = '0' + min;
      }
      if (negative && displaySignIfNegative ){
        return "-" + hours + ":" + min;
      }else{
        if (displaySignIfPositive){
          return '+' + hours + ':' + min;
        }else{
          return hours + ':' + min;
        }
      }
    } else {
      if (displaySignIfPositive){
        return '+000:00';
      }else{
        return '000:00';
      }
    }
  }



  transformWith6Digits(value: number,displaySignIfNegative: boolean = false,displaySignIfPositive: boolean = false): any {
    // console.log('transform ' + JSON.stringify(value) + ' displaySignIfNegative: ' + displaySignIfNegative);
    if (value) {
      let negative = false;
      if (value<0){
        negative = true;
        value = -1*value;
      }
      let hours: string = (this.integerDivider(value, 60))  + '';
      let min: string = this.integerModulo(value ,60)  + '';
      if ( hours.length === 1 ) {
        hours = '0' + hours;
      }
      if ( hours.length === 2 ) {
        hours = '0' + hours;
      }
      if ( hours.length === 3 ) {
        hours = '0' + hours;
      }
      if ( min.length === 1 ) {
        min = '0' + min;
      }
      if (negative && displaySignIfNegative ){
        return "-" + hours + ":" + min;
      }else{
        if (displaySignIfPositive){
          return "+" + hours + ':' + min;
        }else{
          return hours + ':' + min;
        }
      }
    } else {
      if (displaySignIfPositive){
        return '+0000:00';
      }else{
        return '0000:00';
      }
    }
  }




  transformWith7Digits(value: number,displaySignIfNegative: boolean = false,displaySignIfPositive: boolean = false): any {
    // console.log('transform ' + JSON.stringify(value) + ' displaySignIfNegative: ' + displaySignIfNegative);
    if (value) {
      let negative = false;
      if (value<0){
        negative = true;
        value = -1*value;
      }
      let hours: string = (this.integerDivider(value, 60))  + '';
      let min: string = this.integerModulo(value ,60)  + '';
      if ( hours.length === 1 ) {
        hours = '0' + hours;
      }
      if ( hours.length === 2 ) {
        hours = '0' + hours;
      }
      if ( hours.length === 3 ) {
        hours = '0' + hours;
      }
      if ( hours.length === 4 ) {
        hours = '0' + hours;
      }
      if ( min.length === 1 ) {
        min = '0' + min;
      }
      if (negative && displaySignIfNegative ){
        return "-" + hours + ":" + min;
      }else{
        if (displaySignIfPositive){
          return '+' + hours + ':' + min;
        }else{
          return hours + ':' + min;
        }
      }
    } else {
      if (displaySignIfPositive){
        return '+00000:00';
      }else{
        return '00000:00';
      }
    }
  }


  /*
  transform(value: number, fiveDigits:boolean = false): any {
      // console.log('transform ' + JSON.stringify(value));
      if (fiveDigits){
        return this.transformWith5Digits(value);
      }
      if (value) {
          let hours: string = (this.integerDivider(value, 60))  + '';
          let min: string = Math.round((value % 60)) + '';
          if ( hours.length === 1 ) {
              hours = '0' + hours;
          }
          if ( min.length === 1 ) {
              min = '0' + min;
          }
          if (value<0){
            console.log(hours + ':' + min + ' => ' + value);
          }
          return hours + ':' + min;
      } else {
        return '00:00';
      }
  }


  transformWith5Digits(value: number): any {
    // console.log('transform ' + JSON.stringify(value));
    if (value) {
      let hours: string = (this.integerDivider(value, 60))  + '';
      let min: string = (value % 60) + '';
      if ( hours.length === 1 ) {
        hours = '0' + hours;
      }
      if ( hours.length === 2 ) {
        hours = '0' + hours;
      }
      if ( min.length === 1 ) {
        min = '0' + min;
      }
      return hours + ':' + min;
    } else {
      return '000:00';
    }
  }
  */


    retrieveAsMinutes (valueAsText: string): number {
       if (valueAsText) {
          let hour = 0;
          let min = 0;
          let negativeNumber = false;
          let valueToUse = valueAsText;
          if (valueAsText.charAt(0)==='-'){
            negativeNumber = true;
            valueToUse = valueAsText.substr(1);
          }
         if (valueAsText.charAt(0)==='+'){
           negativeNumber = false;
           valueToUse = valueAsText.substr(1);
         }
         // console.log('Value to use is now: ' + valueToUse + ' before it was: ' + valueAsText);
          const idx = valueToUse.indexOf(':');
          if (idx >= 0) {
            const hourPartAsText = valueToUse.substr(0, idx);
            if (hourPartAsText) {
              hour = parseInt(hourPartAsText, 10);
            }
            if (idx + 1 < valueToUse.length) {
              const minutePartAsText = valueToUse.substr(idx + 1, valueToUse.length - idx - 1 );
              min = parseInt(minutePartAsText, 10);
            }
          }
          if (negativeNumber){
            return -1 * (hour * 60 + min);
          }else{
            return hour * 60 + min;
          }
       }
       return 0;
    }

    retrieveAsDate (valueAsText: string, ampmFormat: boolean = false, refDate?:Date ): Date {
      if (valueAsText) {
        let hour = 0;
        let min = 0;
        let sec = 0;
        const idx = valueAsText.indexOf(':');
        // let am = false;
        let pm = false;
        let idxAmPm = -1;
        if (ampmFormat){
          idxAmPm = valueAsText.toUpperCase().indexOf('AM');
          if (idxAmPm>=0){
            // am = true;
          }else{
            idxAmPm = valueAsText.toUpperCase().indexOf('PM');
            if (idxAmPm>=0){
              pm = true;
            }
          }
        }
        if (idx >= 0) {
          const hourPartAsText = valueAsText.substr(0, idx);
          if (hourPartAsText) {
            hour = parseInt(hourPartAsText, 10);
            if (ampmFormat) {
              if (pm) {
                if (hour!==12){
                  hour += 12;
                }
              }else{
                 // am
                if (hour===12){
                  hour = 0;
                }
              }
            }
          }
          if (idx + 1 < valueAsText.length) {
            // let minutePartAsText = valueAsText.substr(idx + 1, valueAsText.length - idx - 1 );
            const minutePartAsText = valueAsText.substr(idx + 1, 2 );
            // if (idxAmPm>=0){
            //   minutePartAsText = valueAsText.substr(idx + 1, valueAsText.length - idx - 1 - idxAmPm );
            // }
            min = parseInt(minutePartAsText, 10);
          }
          if ((idx + 4 < valueAsText.length) && (ampmFormat===false)) {
            // let minutePartAsText = valueAsText.substr(idx + 1, valueAsText.length - idx - 1 );
            const secondPartAsText = valueAsText.substr(idx + 4, 2 );
            // console.log('SEcondPartAsText ' + secondPartAsText);
            // if (idxAmPm>=0){
            //   minutePartAsText = valueAsText.substr(idx + 1, valueAsText.length - idx - 1 - idxAmPm );
            // }
            sec = parseInt(secondPartAsText, 10);
            // console.log('SEcondPartAsText as int:  ' + sec);
          }
        }
        // if (ampmFormat){
        //   if (pm){
        //     return moment({hour: hour + 12, minute: min}).toDate();
        //   }else{
        //     return moment({hour: hour, minute: min}).toDate();
        //   }
        // }else{
        if (hour==24){
          /**
           * Without refDate momentJS doesn't like 24:20 for example, with a ref date not an issue.
           */
          console.log('refDate: ' + refDate + " hour: " + hour + " replacing the hour with 0, min: " + min);
          hour = 0;
        }

        if (refDate){
          return moment(refDate).hour(hour).minute(min).second(sec).toDate();
        }else{
          return moment({hour: hour, minute: min, second: sec}).toDate();
        }
        // }
        // return hour * 60 + min;
      }
      return null;
    }


}
